import { msg, Trans } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { useState } from "react";
import ContainerTextHeader from "../../common/ContainerTextHeader";
import Footer from "../../common/Footer";
import FooterButton from "../../common/FooterButton";
import useInterval from "../../common/lib/hooks/useInterval";
import useIsAnonymous from "../../common/lib/hooks/useIsAnonymous";
import SwitchToMobileQRCode from "../../common/SwitchToMobileQRCode";
import ScanButton from "../../dev/ScanButton";
import { useGetPastPurchaseOrderByStagedPurchaseOrderId } from "../../requests/Receiving/useGetPastPurchaseOrderByStagedPurchaseOrderId";

interface ReceivingTicketInstructionsProps {
  stagedPurchaseOrderId: string,
  additionalInstructions: string | undefined,
  receivingCompleted: () => void,
}

const ReceivingTicketInstructions = (props: ReceivingTicketInstructionsProps) => {
  const { _ } = useLingui();

  const [stagedPurchaseOrderComplete, setStagedPurchaseOrderComplete] = useState<boolean>(false);
  const isAnonymous = useIsAnonymous();

  const refreshTimeMs = 3000;
  const completeTimeMs = 15000;

  const stageOrderCompleted = useGetPastPurchaseOrderByStagedPurchaseOrderId(props.stagedPurchaseOrderId, {
    onSuccess: _ => setStagedPurchaseOrderComplete(true)
  });

  useInterval(() => stageOrderCompleted.query(), refreshTimeMs, true);

  useInterval(() => isAnonymous && stagedPurchaseOrderComplete ? props.receivingCompleted() : null, completeTimeMs, false);

  return <ContainerTextHeader
    message={_(msg`Pick up ticket at printer`)}
    devToolItems={<ScanButton stagedPurchaseOrderId={props.stagedPurchaseOrderId} location='ReceivingTicketCreated' />}>

    {isAnonymous && <SwitchToMobileQRCode />}
    <div className="m-auto" style={{ wordBreak: "break-word" }}>
      <label className="text-center h2">
        {props.additionalInstructions}
      </label>
    </div>
    <Footer nextButton={
      <FooterButton
        className={`${isAnonymous ? 'invisible' : ''}`}
        disabled={!stagedPurchaseOrderComplete}
        onClick={() => props.receivingCompleted()}>
        <Trans>Done</Trans>
      </FooterButton>
    } />
  </ContainerTextHeader >
}

export default ReceivingTicketInstructions;
